import { Component, DestroyRef, inject, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../../services/translator_service';
import { ResponsiveService } from '../../../../services/responsive.service';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ApiQuery } from '../../../../web-services/api/api.query';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bin-analytics',
  imports: [TranslatePipe, RTLDivDirectiveDirective,CommonModule,NgCircleProgressModule],
  templateUrl: './bin-analytics.html',
  styleUrl: './bin-analytics.scss',
})
export class BinAnalytics {
  isMobile: Boolean;
	translationsObj;
	currentLang;
  usageType = 1;
	selectedBinInfo: any = null;
	private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery:ApiQuery) {
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
    this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (!user) return;
      if(user["usage_type_id"] != 1){
        this.usageType = user["usage_type_id"];
      }
    });

    this.apiQuery.binInfo$.pipe(takeUntil(this.destroy$)).subscribe((info) => {
			if (!info) {
				return;
			}
			this.selectedBinInfo = info;
		});
  }

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }
}
